// extracted by mini-css-extract-plugin
export default {"supportButton":"SupportButton_supportButton__lGlGV","icon":"SupportButton_icon__tQhXy","text":"SupportButton_text__FdVxZ","hovered":"SupportButton_hovered__W0Mdb"};